export async function MountTimeTable(props: any, el: Element) {
	const module = await import('./TimeTable');
	module.MountTimeTable(props, el);
}

(window as any).MountTimeTable = MountTimeTable;
